/**
 * Builds an Algolia filter that looks up a product by its unique objectID (= part number), bypassing ranking/rules.
 * objectID filters are case-sensitive, so the term is matched both as typed and upper-cased.
 */
export const buildExactMatchFilter = (query: string): string => {
  const term = query.trim();
  return [...new Set([term, term.toUpperCase()])]
    .map((value) => `objectID:"${value.replace(/["\\]/g, "\\$&")}"`)
    .join(" OR ");
};
